import {useNavigate} from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import React from "react";
import useRenderTextEditorContent from "../../../hooks/useTextEditorContent";
import helpers from "../../../utils/common-functions/Helper";
import {TruncatedHtmlTextContent} from "../../../components/TruncatedHtmlTextContent/TruncatedHtmlTextContent";

const ProgramMasterclassCard = ({ masterClass, isPreview = true }) => {
    const navigate = useNavigate();
    const renderAnswer = useRenderTextEditorContent();

    const handleNavigate = () => {
        const url = isPreview ? "/master-classes/" + masterClass.id : `/master-classes/${masterClass.id}/preview`;

        navigate(url);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 col-12">
                <div className={`card text-white m-3 p-4 program-masterclass-card rounded-3 ${
                    masterClass?.is_completed ? "overlay-completed master-class-completed-opacity" : ""
                }`} onClick={handleNavigate}>
                    <img src={masterClass?.cover_image} className="card-img-top program-masterclass-card-thumbnail img-fluid rounded-3 mb-3"
                         alt={masterClass?.name}/>
                    <h5 className="card-title mb-3">{masterClass?.name}</h5>
                    <div className="mb-3">
                        <TruncatedHtmlTextContent
                            text={masterClass?.description}
                            lineClamp={2}
                        />
                    </div>
                    {isPreview &&
                        <ProgressBar completed={masterClass.progress} bgColor="#1c64f2" baseBgColor="#374151"
                                     className={`w-100 progressbar-count mt-2 ${masterClass.progress > 5 ? '' : 'progressbar-count__hide-value'}`}/>
                    }
                    {masterClass?.completed_lessons > 0 &&
                        <div className="mt-1">
                                            <span className="fs-6 lh-base fw-bolder text-secondary">
                                                {helpers.pluralize(masterClass?.completed_lessons, "watched lesson", "watched lessons")}
                                            </span>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default ProgramMasterclassCard;